import { Component, ChangeDetectionStrategy, input } from '@angular/core';

import { RateLockInfoData } from 'src/app/shared/models/app.model';


@Component({
    selector: 'app-rate-lock-information',
    templateUrl: './rate-lock-information.component.html',
    styleUrls: ['./rate-lock-information.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateLockInformationComponent {
  readonly rateLockInfo = input<RateLockInfoData | undefined>();
}
